/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type IncentiveBasis = typeof IncentiveBasis[keyof typeof IncentiveBasis];


export const IncentiveBasis = {
  per_unit: 'per_unit',
  flat: 'flat',
} as const;
